const navActive = (state = false, action) => {
    switch(action.type) {
        case 'navActive':
            return action.payload;
        default:
            return state;
    }
}

export default navActive;